// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./Idiomas/en/translation.json";
import es from "./Idiomas/es/translation.json";
import ch from "./Idiomas/ch/translation.json";
import dk from "./Idiomas/dk/translation.json";
import nl from "./Idiomas/nl/translation.json";
import garmentProdChecklistEs from "./Idiomas/garmentProdChecklist/es.json";
import garmentProdChecklistEn from "./Idiomas/garmentProdChecklist/en.json";
import garmentProdChecklistCh from "./Idiomas/garmentProdChecklist/ch.json";
import garmentProdChecklistDk from "./Idiomas/garmentProdChecklist/dk.json";
import garmentProdChecklistNl from "./Idiomas/garmentProdChecklist/nl.json";
import incotermsEs from "./Idiomas/incoterms/es.json";
import incotermsEn from "./Idiomas/incoterms/en.json";
import incotermsCh from "./Idiomas/incoterms/ch.json";
import incotermsDk from "./Idiomas/incoterms/dk.json";
import incotermsNl from "./Idiomas/incoterms/nl.json";
import crearMensajesEs from "./Idiomas/crearMensajes/es.json";
import crearMensajesEn from "./Idiomas/crearMensajes/en.json";
import crearMensajesCh from "./Idiomas/crearMensajes/ch.json";
import crearMensajesDk from "./Idiomas/crearMensajes/dk.json";
import crearMensajesNl from "./Idiomas/crearMensajes/nl.json";
import crearMensajesRefEs from "./Idiomas/crearMensajes/referenceGuide.es.json";
import crearMensajesRefEn from "./Idiomas/crearMensajes/referenceGuide.en.json";
import crearMensajesRefCh from "./Idiomas/crearMensajes/referenceGuide.ch.json";
import crearMensajesRefDk from "./Idiomas/crearMensajes/referenceGuide.dk.json";
import crearMensajesRefNl from "./Idiomas/crearMensajes/referenceGuide.nl.json";
import organigramaEs from "./Idiomas/organigrama/es.json";
import organigramaEn from "./Idiomas/organigrama/en.json";
import organigramaRolesEn from "./Idiomas/organigrama/roles/en.json";
import organigramaRolesEs from "./Idiomas/organigrama/roles/es.json";
import organigramaRolesCh from "./Idiomas/organigrama/roles/ch.json";
import organigramaRolesDk from "./Idiomas/organigrama/roles/dk.json";
import organigramaRolesNl from "./Idiomas/organigrama/roles/nl.json";
import organigramaCh from "./Idiomas/organigrama/ch.json";
import organigramaDk from "./Idiomas/organigrama/dk.json";
import organigramaNl from "./Idiomas/organigrama/nl.json";
import helpEs from "./Idiomas/help/es.json";
import helpEn from "./Idiomas/help/en.json";
import helpCh from "./Idiomas/help/ch.json";
import helpDk from "./Idiomas/help/dk.json";
import helpNl from "./Idiomas/help/nl.json";
import skillAgentEs from "./Idiomas/skillAgent/es.json";
import skillAgentEn from "./Idiomas/skillAgent/en.json";
import skillAgentCh from "./Idiomas/skillAgent/ch.json";
import skillAgentDk from "./Idiomas/skillAgent/dk.json";
import skillAgentNl from "./Idiomas/skillAgent/nl.json";
import pygAnaliticoEs from "./Idiomas/pygAnalitico/es.json";
import pygAnaliticoEn from "./Idiomas/pygAnalitico/en.json";
import pygAnaliticoCh from "./Idiomas/pygAnalitico/ch.json";
import pygAnaliticoDk from "./Idiomas/pygAnalitico/dk.json";
import pygAnaliticoNl from "./Idiomas/pygAnalitico/nl.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...en,
          pygAnalitico: pygAnaliticoEn,
          help: helpEn,
          skillAgent: skillAgentEn,
          garmentProdChecklist: garmentProdChecklistEn,
          incoterms: incotermsEn,
          crearMensajes: {
            ...crearMensajesEn,
            referenceGuide: crearMensajesRefEn,
          },
          organigrama: { ...organigramaEn, roles: organigramaRolesEn },
        },
      },
      es: {
        translation: {
          ...es,
          pygAnalitico: pygAnaliticoEs,
          help: helpEs,
          skillAgent: skillAgentEs,
          garmentProdChecklist: garmentProdChecklistEs,
          incoterms: incotermsEs,
          crearMensajes: {
            ...crearMensajesEs,
            referenceGuide: crearMensajesRefEs,
          },
          organigrama: { ...organigramaEs, roles: organigramaRolesEs },
        },
      },
      ch: {
        translation: {
          ...ch,
          pygAnalitico: pygAnaliticoCh,
          help: helpCh,
          skillAgent: skillAgentCh,
          garmentProdChecklist: garmentProdChecklistCh,
          incoterms: incotermsCh,
          crearMensajes: {
            ...crearMensajesCh,
            referenceGuide: crearMensajesRefCh,
          },
          organigrama: { ...organigramaCh, roles: organigramaRolesCh },
        },
      },
      dk: {
        translation: {
          ...dk,
          pygAnalitico: pygAnaliticoDk,
          help: helpDk,
          skillAgent: skillAgentDk,
          garmentProdChecklist: garmentProdChecklistDk,
          incoterms: incotermsDk,
          crearMensajes: {
            ...crearMensajesDk,
            referenceGuide: crearMensajesRefDk,
          },
          organigrama: { ...organigramaDk, roles: organigramaRolesDk },
        },
      },
      nl: {
        translation: {
          ...nl,
          pygAnalitico: pygAnaliticoNl,
          help: helpNl,
          skillAgent: skillAgentNl,
          garmentProdChecklist: garmentProdChecklistNl,
          incoterms: incotermsNl,
          crearMensajes: {
            ...crearMensajesNl,
            referenceGuide: crearMensajesRefNl,
          },
          organigrama: { ...organigramaNl, roles: organigramaRolesNl },
        },
      },
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // React ya hace el escaping
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
